<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    红岭站<br>
站点介绍<br>
红岭站是3号线和9号线的换乘车站，位于福田区红岭中路与红荔路的交叉路口西侧，沿红荔路东西向布置。北侧为园岭片区，南侧为荔枝公园，东南侧为地王商业区，东北侧为松园南街、博爱医院、深圳鹏程医院、松园派出所等，装修设计突出“荔枝公园”感观、色彩基调为“白色+红色” ，让乘客在第一眼就感受到荔枝的芬芳，该站为地下段。<br><br>
运营时刻表(工作日)<br>
<table border="1">
  <tr>
  <td>行驶方向</td>
  <td>首班车</td>
  <td>末班车</td>
  <td>所属线路</td>
  <td>高峰间隔</td>
  <td>平峰间隔</td></tr>

  <tr>
  <td>福保</td>
  <td>06:20</td>
  <td>23:54</td>
  <td>3号线</td>
  <td>2分15-20秒</td>
  <td>4分30秒</td>
</tr>

  <tr>
  <td>双龙</td>
  <td>06:03</td>
  <td>23:19</td>
  <td>3号线</td>
  <td>2分15-20秒</td>
  <td>4分30秒</td>
</tr>

<tr>
  <td>前湾</td>
  <td>06:29</td>
  <td>23:09</td>
  <td>9号线</td>
  <td>3分50秒</td>
  <td>5分55秒</td>
</tr>

<tr>
  <td>文锦</td>
  <td>06:18</td>
  <td>23:59</td>
  <td>9号线</td>
  <td>3分50秒</td>
  <td>5分55秒</td>
</tr>
</table>
<br>

运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:29	23:53	3号线	3分15秒	5分钟<br>
双龙	06:04	23:19	3号线	3分15秒	5分钟<br>
前湾	06:30	23:10	9号线	4分25秒	5分55秒<br>
文锦	06:17	23:59	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:29	00:53	3号线	3分15秒	5分钟<br>
双龙	06:04	00:19	3号线	3分15秒	5分钟<br>
前湾	06:30	00:10	9号线	4分钟	5分55秒<br>
文锦	06:15	00:59	9号线	4分钟	5分55秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
荔枝公园、深圳市青少年活动中心、市少儿图书馆、深圳文艺会堂、银盛大厦、市文联(在9号线B出入口)、青年广场、中国共产主义青年团深圳市委员会<br><br>
B出入口:<br>
红荔路南侧（西）、中国共产主义青年团深圳市委员会、深圳市青年宫、红岭美术馆<br><br>
C1出入口:<br>
园岭新村<br><br>
C2出入口:<br>
红桂大厦、都汇中心(归属于9号线红岭管辖范围)<br><br>
D出入口:<br>
红荔路(北）、园岭新村、红岭中学<br><br>
E出入口:<br>
深圳人一天雕塑公园、园岭小学、园岭实验小学、园岭三街、园岭外国语小学<br><br>
F出入口:<br>
红岭中路（西）、银荔大厦、儿童乐园、荔枝公园<br><br>
G出入口:<br>
红岭中路（东）、红宝路、美荔园、国信证券大厦、深圳国际信托大厦、荔景大厦、威登别墅、蔡屋围金龙大厦、深圳希思医疗美容医院、最高人民法院第一巡回法庭<br><br>
H出入口:<br>
红桂路（南）、福彩中心、红岭集团南区住宅区、阳光庄园<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 红岭地铁站<br>
64路，108路，225路，393路，7路<br><br>
B出入口:<br>
公交站名： 红岭地铁站<br>
108路，225路，64路，7路、393路、M207（原207）<br><br>
C出入口:<br>
公交站名： 红岭地铁站<br>
64路，108路，225路，322路<br><br>
D出入口:<br>
公交站名： 红岭地铁站<br>
64路，108路，225路，322路<br><br>
E出入口:<br>
公交站名： 少儿图书馆站<br>
（原来信息10路,13路,30路,59路,64路,65路,80路,K105路,108路,123路,202路,225路,303路,311路,383路,N6路）改为 10路,13路,64路,80路,108路,202路,225路,303路,322路，322路,m183路（原383）,m105路（原k105)，m481，m555(原65），m555大站快车，7路，N25路<br><br>
F出入口:<br>
公交站名： 荔枝公园2<br>
23路，63路，7路，85路，E8路，N10路<br><br>
F出入口:<br>
公交站名： 荔枝公园1<br>
10路、393路、E25路、M152（原352）路，M360路，M401路，M463路，M481路<br><br>
G出入口:<br>
公交站名： 荔枝公园2<br>
23路，63路，7路，85路，N10路<br><br>
G出入口:<br>
公交站名： 荔枝公园1<br>
M463路，M481路，E8路，10路，E25路，M152（原352）路，M360，M401<br><br>
H出入口:<br>
公交站名： 红桂路口<br>
108路，80路，108路，M183（原383）<br><br>
C2出入口:<br>
公交站名： 红桂路口<br>
108路，M183（原383）<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "jiuhaoxian",
          title: "9号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>